import(/* webpackMode: "eager" */ "/var/www/front/safiruni/front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/front/safiruni/front/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/front/safiruni/front/public/images/404.svg");
